<template>
  <!-- <div class="sidebar-header"></div> -->
</template>
<script>

export default {
  name: 'sidebar-header'
}
</script>



// WEBPACK FOOTER //
// SidebarHeader.vue?6e2d0cad